import { render, staticRenderFns } from "./SimplyLogin.vue?vue&type=template&id=3447c54e&scoped=true"
import script from "./SimplyLogin.vue?vue&type=script&lang=js"
export * from "./SimplyLogin.vue?vue&type=script&lang=js"
import style0 from "./SimplyLogin.vue?vue&type=style&index=0&id=3447c54e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3447c54e",
  null
  
)

export default component.exports